import { motion } from "framer-motion";
import { Quote } from "lucide-react";

export default function Testimonial() {
  return (
    <section
      id="about"
      data-testid="testimonial-section"
      className="py-24 md:py-32 lg:py-40 bg-white border-b border-zinc-200"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 text-center">
        <div className="text-xs font-mono uppercase tracking-widest text-zinc-500 mb-8">
          [ 05 — CLIENT VOICES ]
        </div>
        <Quote className="w-10 h-10 mx-auto text-[#002FA7] mb-8" strokeWidth={1.5} />
        <motion.blockquote
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          data-testid="testimonial-quote"
          className="font-display font-bold uppercase tracking-tight leading-[1.05] text-4xl md:text-5xl lg:text-6xl xl:text-7xl max-w-6xl mx-auto"
        >
          &ldquo;Slide Ventures isn&apos;t an agency — they&apos;re the growth team we couldn&apos;t
          hire. In eight months they added a{" "}
          <span className="text-[#002FA7]">seven-figure</span> channel we didn&apos;t
          know we had.&rdquo;
        </motion.blockquote>
        <div className="mt-12 flex items-center justify-center gap-4">
          <img
            src="https://images.pexels.com/photos/1170412/pexels-photo-1170412.jpeg?auto=compress&cs=tinysrgb&w=200"
            alt="Amelia Osei"
            className="w-12 h-12 object-cover grayscale rounded-none"
          />
          <div className="text-left">
            <div className="font-display font-bold uppercase text-sm tracking-tight">
              Amelia Osei
            </div>
            <div className="text-xs font-mono uppercase tracking-widest text-zinc-500">
              Head of Growth · Kubex
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
